module.exports = __webpack_public_path__ + "media/images/elionline/issuu-878d58d710cbe75c97e8caac1b966b5a.png";